<template>
  <div>
    <px-view-header v-if="!isModalView"
                    title="Respostas da cotação" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link to="/cotacoes">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading">
      <px-cotacao-resposta-comprador-card :cotacao="cotacao"
                                          :solicitacoes="solicitacoes"
                                          @movimentada="onMovimentarCotacao"/>
      <px-cotacao-resposta-line-options :cotacao="cotacao"
                                        @change-search-text="onChangeSearchText"
                                        @change-sort="onChangeSort"
                                        @change-view="onChangeView"/>

      <div class="mb-3 text-right" v-if="cotacaoId">
          <px-cotacao-resposta-sem-estoque :cotacao-id="cotacaoId" />
      </div>

      <px-cotacao-resposta-view-fornecedor v-if="isFornecedor"
                                           :cotacao="cotacao"
                                           :cotacao-id="cotacaoId"
                                           :search-text="searchText"
                                           :selected-sort="selectedSort"
                                           :is-modal-view="isModalView"/>
      <px-cotacao-resposta-view-produto v-if="isProduto"
                                        :cotacao="cotacao"
                                        :cotacao-id="cotacaoId"
                                        :search-text="searchText"
                                        :selected-sort="selectedSort"
                                        :is-modal-view="isModalView"/>
    </div>
  </div>
</template>

<script>
import CotacaoRespostaCompradorCard from './CotacaoRespostaCompradorCard.vue';
import CotacaoRespostaLineOptions from './CotacaoRespostaLineOptions.vue';
import CotacaoRespostaViewFornecedor from './CotacaoRespostaViewFornecedor.vue';
import CotacaoRespostaViewProduto from './CotacaoRespostaViewProduto.vue';
import CotacaoRespostaSemEstoque from './CotacaoRespostaSemEstoque.vue';
import CotacaoService from '../cotacao-service';

export default {
  props: {
    isModalView: {
      type: Boolean,
      default: false,
    },
    cotacaoIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      cotacaoId: null,
      cotacao: null,
      solicitacoes: null,
      loading: false,
      searchText: null,
      selectedSort: null,
      viewType: null,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        {
          text: 'Cotações',
          to: '/cotacoes',
        },
        { text: 'Respostas' },
      ],
    };
  },
  computed: {
    isFornecedor() {
      return this.viewType && this.viewType.value === 'FORNECEDOR';
    },
    isProduto() {
      return this.viewType && this.viewType.value === 'PRODUTO';
    },
  },
  methods: {
    onChangeSearchText(text) {
      this.searchText = text;
    },
    onChangeSort(sort) {
      this.selectedSort = sort;
    },
    onChangeView(view) {
      this.viewType = view;
    },
    getCotacao() {
      this.loading = true;
      CotacaoService.getCotacao(this.cotacaoId)
        .then((response) => {
          this.cotacao = response.data;
          return this.getSolicitacoes();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSolicitacoes() {
      CotacaoService.getSolicitacoes(this.cotacaoId)
        .then(({ data }) => {
          this.solicitacoes = data;
        });
    },
    onMovimentarCotacao() {
      this.getCotacao();
    },
  },
  created() {
    this.cotacaoId = this.cotacaoIdProp || this.$route.params.id;
    this.getCotacao();
  },
  components: {
    pxCotacaoRespostaCompradorCard: CotacaoRespostaCompradorCard,
    pxCotacaoRespostaLineOptions: CotacaoRespostaLineOptions,
    pxCotacaoRespostaViewFornecedor: CotacaoRespostaViewFornecedor,
    pxCotacaoRespostaViewProduto: CotacaoRespostaViewProduto,
    pxCotacaoRespostaSemEstoque: CotacaoRespostaSemEstoque,
  },
};
</script>
